/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import { Box, Typography, Checkbox } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PATH_EXTERNAL } from 'src/routes/paths';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import bannerPopup from '../../mocks/_banner-popup.json';

export default function BannerPopup() {
  const bannerData = bannerPopup;
  const [isOpen, setIsOpen] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const opennedBanner = sessionStorage.getItem('opened_banner') ?? 'false';
  const setLocal = (key, value) => {
    // 5 Day
    const fiveDayMillisecode = 5 * 24 * 60 * 60 * 1000;
    const expiresAt = Date.now() + fiveDayMillisecode; // days → ms

    const data = {
      value,
      expiresAt,
    };

    localStorage.setItem(key, JSON.stringify(data));
  };

  const getLocal = (key) => {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);

      if (parsed.expiresAt && Date.now() > parsed.expiresAt) {
        localStorage.removeItem(key);
        return null;
      }

      return parsed.value;
    } catch {
      return null;
    }
  };

  const isShowAgain = getLocal('IS_SHOW_AGAIN') ?? true;

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem('opened_banner', 'true');
    setLocal('IS_SHOW_AGAIN', !isChecked);
  };

  if (isShowAgain && isOpen && opennedBanner === 'false') {
    return (
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 1300,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          bgcolor: 'rgba(0, 0, 0, 0.6)',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: `60vh`,
            display: 'flex',
            flexDirection: 'column',
            inset: 0,
            overflow: 'unset',
            borderRadius: '8px',
            outline: 'none',
            padding: '20px !important',
          }}
        >
          <Box
            onClick={() => handleClose()}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mb: '16px',
              cursor: 'pointer',
            }}
          >
            <img
              src="/assets/close-white.svg"
              alt="close-logo"
              className="img-close-search"
              style={{}}
            />
          </Box>
          <Swiper>
            {bannerData.map((item, i) => (
              <SwiperSlide
                key={i}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Box
                  onClick={async () => {
                    window.open(PATH_EXTERNAL.downloadMyKTAXA);
                  }}
                  sx={{
                    cursor: 'pointer',
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }}
                >
                  <img src={item.image_banner.url} alt={item.image_banner.alt ?? 'banner'} />
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
          <Box
            sx={{
              mt: '8px',
              py: '8px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1,
              fontSize: 14,
              color: 'white',
            }}
          >
            <Checkbox
              sx={{
                width: 16,
                height: 16,
                color: 'white',
                borderRadius: 1,
                '&.Mui-checked': {
                  color: '#00008F',
                },
                '&.Mui-focusVisible': {
                  outline: () => `2px solid #00008F`,
                  outlineOffset: 2,
                },
              }}
              onChange={(e) => {
                setIsChecked(e.target.checked);
              }}
            />
            <Typography
              sx={{
                fontSize: 20,
                color: 'white',
              }}
            >
              ไม่ต้องแสดงอีก
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }
}
